export interface PacketLookupItem {
  value: string;
  text: string;
}
